import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import {
  TextInputLabel,
  RequiredFieldDivError,
} from "./AddEditFinacialInformation.styled";
import {
  autoSearchInputStylesError,
  autoSearchInputStyles,
} from "@utils/extra-style";
import UserInfo from "@utils/UserInfo";

const HolderCompany = (props) => {
  const {
    t,
    formData,
    setFormData,
    objectId,
    isEditMode,
    selectedHolderCompany,
  } = props;

  const countryId = UserInfo.countryId();
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [isCompanySuggestionsLoading, setCompanySuggestionsLoading] =
    useState(false);

  useEffect(() => {
    setFormData({
      ...formData,
      company: {
        value: selectedCompany,
        error: "",
        required: true,
      },
    });
  }, [selectedCompany]);

  useEffect(() => {
    if (!isEditMode) {
      let entityGroupList = [];
      if (formData?.company?.value?.id) {
        entityGroupList.push({
          name: selectedHolderCompany?.id + " - " + selectedHolderCompany?.name,
          id: selectedHolderCompany?.id,
        });
      }
      if (!formData?.company?.value?.id) {
        entityGroupList.push({
          name: selectedHolderCompany?.nameText,
        });
      }
      setSelectedCompany(entityGroupList[0]);
    } else if (!isEditMode && objectId !== null) {
      const url = `/general/search?search=&limit=50&countries=[${countryId}]&objectId=${objectId}&objectTypes=["company"]`;
      getEntityData(url, "selectedDefault");
    }
  }, []);

  const searchEntity = (e) => {
    const search = e.target.value;
    setSelectedCompany({ name: search });
    if (search.length >= 3) {
      let url = `/general/search?search=${search}&limit=50&countries=[${countryId}]&objectTypes=["company"]`;
      getEntityData(url, "all");
    }
  };
  const getEntityData = (url, type) => {
    setCompanySuggestionsLoading(true);
    axios
      .get(url)
      .then((response) => {
        let entityGroupList = [];
        if (response?.data?.companies) {
          response.data.companies.map((key) => {
            entityGroupList.push({
              name: key.id + " - " + key.name,
              id: key.id,
            });
          });
          setCompanyList(entityGroupList);
          setCompanySuggestionsLoading(false);
          if (
            type === "selectedDefault" &&
            response.data.companies.length === 1
          ) {
            setSelectedCompany(entityGroupList[0]);
          }
        }
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching entities",
            error
          );
        }
        setCompanyList([]);
        setCompanySuggestionsLoading(false);
      });
  };

  return (
    <>
      <TextInputLabel error={formData.company.error}>
        {" "}
        {t("SITE_DELEGATION_COMPANY")}
        {isCompanySuggestionsLoading && (
          <ClipLoader size={15} background="#15aee5 !important" />
        )}
      </TextInputLabel>
      <Autocomplete
        id="tags-outlined"
        style={{ zIndex: 99 }}
        value={selectedCompany}
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            setSelectedCompany({
              name: newValue,
            });
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            setSelectedCompany({
              name: newValue.inputValue,
            });
          } else {
            setSelectedCompany(newValue);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);

          const { inputValue } = params;
          // Suggest the creation of a new value
          const isExisting = options.some((option) => inputValue === option.id);
          //   if (inputValue !== "" && !isExisting) {
          //     filtered.push({
          //       inputValue,
          //       name: inputValue,
          //     });
          //   }

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={companyList}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option || " ";
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue || " ";
          }
          // Regular option
          return option.name || " ";
        }}
        // getOptionLabel={(option) => option.name || " "}
        // renderOption={(props, option) => {
        //   const { key, ...optionProps } = props;
        //   return (
        //     <li key={key} {...optionProps}>
        //       {option.title}
        //     </li>
        //   );
        // }}
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        onKeyUp={searchEntity}
        sx={{ width: 300 }}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder=""
            size="small"
            style={
              formData.company.error !== ""
                ? autoSearchInputStylesError
                : autoSearchInputStyles
            }
          />
        )}
      />

      {formData.company.error !== "" && (
        <RequiredFieldDivError>{formData.company.error}</RequiredFieldDivError>
      )}
    </>
  );
};

HolderCompany.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  objectId: PropTypes.number,
};

HolderCompany.defaultProps = {
  isEditMode: false,
  objectId: null,
};
export default withTranslation()(HolderCompany);
